import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { getApiBaseUrl, getStaticBaseUrl } from '../../stores/configStore';

function isImage(fileName) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
}

  function getFileUrl(fileUrl) {
  if (fileUrl.startsWith('/uploads/')) {
    return `${getStaticBaseUrl()}${fileUrl}`;
  }
  return fileUrl;
}

function FileAttachmentsModal({
  open,
  onClose,
  week,
  dayOfWeek,
  slotIndex,
  startTime,
  endTime,
  studentId,
  groupId,
  readOnly = false,
  showUploader = true,
  currentUserId = null,
  subject = null
}) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef();

  // Грузим файлы при первом открытии и при смене ключевых параметров
  useEffect(() => {
    if (!open) return;
    fetchFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, week, dayOfWeek, slotIndex, startTime, endTime, studentId, groupId]);

  // Сброс состояния при закрытии
  useEffect(() => {
    if (!open) {
      setInitialized(false);
    }
  }, [open]);

  const fetchFiles = async () => {
    // Если модалка уже инициализирована, не показываем повторный спиннер
    if (!initialized) setLoading(true);
    setError('');
    try {
      const params = { week, dayOfWeek };
      if (slotIndex !== undefined && slotIndex !== null && slotIndex !== '') params.slotIndex = slotIndex;
      if (startTime) params.startTime = startTime;
      if (endTime) params.endTime = endTime;
      if (studentId) params.studentId = studentId;
      if (groupId) params.groupId = groupId;
      if (!params.date && window.__slotDate) params.date = window.__slotDate;
      console.log('[FilesModal] GET /schedule/attachments params:', params);
      const { data } = await axios.get(`${getApiBaseUrl()}/schedule/attachments`, { params });
      console.log('[FilesModal] attachments loaded:', Array.isArray(data) ? data.length : data);
      setFiles(data);
      if (!initialized) setInitialized(true);
    } catch (e) {
      console.warn('[FilesModal] attachments load error:', e?.response?.data || e?.message);
      // Не обнуляем список, чтобы избежать мерцаний
      setError('Ошибка при получении файлов');
    } finally {
      if (!initialized) setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    const selectedFiles = Array.from(e.target.files).slice(0, 4);
    if (!selectedFiles.length) return;
    setUploading(true);
    setError('');
    try {
      for (const file of selectedFiles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('week', week);
        formData.append('dayOfWeek', dayOfWeek);
        if (slotIndex !== undefined && slotIndex !== null && slotIndex !== '') formData.append('slotIndex', slotIndex);
        if (startTime) formData.append('startTime', startTime);
        if (endTime) formData.append('endTime', endTime);
        if (window.__slotDate) formData.append('date', window.__slotDate);
        // Если это индивидуальный слот (есть studentId и нет groupId) — передаём studentId
        if (studentId && !groupId) {
          formData.append('studentId', studentId);
         }
        if (groupId) formData.append('groupId', groupId);
        if (currentUserId) formData.append('userId', currentUserId);
        if (subject) formData.append('subject', subject);
        console.log('[FilesModal] POST /schedule/attachment body:', {
          week, dayOfWeek, slotIndex, startTime, endTime, date: window.__slotDate, studentId, groupId, currentUserId, subject
        });
        const res = await axios.post(`${getApiBaseUrl()}/schedule/attachment`, formData);
        console.log('[FilesModal] upload ok:', res?.status);
      }
      await fetchFiles();
      if (fileInputRef.current) fileInputRef.current.value = '';
    } catch (e) {
      console.error('[FilesModal] upload error:', e?.response?.data || e?.message);
      setError(e.response?.data?.message || 'Ошибка при загрузке файла');
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (fileUrl) => {
    if (!window.confirm('Удалить файл?')) return;
    setUploading(true);
    setError('');
    try {
      await axios.delete(`${getApiBaseUrl()}/schedule/attachment`, {
        data: {
          week,
          dayOfWeek,
          slotIndex,
          startTime,
          endTime,
          studentId,
          groupId,
          fileUrl
        }
      });
      await fetchFiles();
    } catch (e) {
      setError('Ошибка при удалении файла');
    } finally {
      setUploading(false);
    }
  };

  // Фильтрация файлов: если передан currentUserId, показываем только свои файлы
  const filteredFiles = currentUserId
    ? files.filter(f => f.user && String(f.user._id) === String(currentUserId))
    : files;

  if (!open) return null;

  const modal = (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="modal-content" style={{ background: '#fff', borderRadius: 16, padding: 28, minWidth: 340, maxWidth: 440, position: 'relative', boxShadow: '0 4px 32px #ece9f7', width: '100%' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 14, right: 18, background: 'transparent', border: 'none', fontSize: 26, cursor: 'pointer', color: '#888', transition: 'color 0.2s' }} aria-label="Закрыть" onMouseOver={e => e.target.style.color='#6c3be4'} onMouseOut={e => e.target.style.color='#888'}>×</button>
        <h2 style={{ marginBottom: 20, textAlign: 'center', fontWeight: 700, fontSize: 24, letterSpacing: 0.5 }}>Файлы слота</h2>
        {showUploader && !readOnly && (
          <div style={{ marginBottom: 18, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' }}>
            <label htmlFor="file-upload" style={{ display: 'inline-block', background: uploading ? '#ccc' : '#6c3be4', color: '#fff', padding: '10px 22px', borderRadius: 8, fontWeight: 500, fontSize: 16, cursor: uploading ? 'not-allowed' : 'pointer', marginBottom: 4, transition: 'background 0.2s' }}>
              Выбрать файлы
            </label>
            <input
              id="file-upload"
              type="file"
              ref={fileInputRef}
              onChange={handleUpload}
              disabled={uploading}
              multiple
              accept="*"
              style={{ display: 'none' }}
            />
            {/* <div style={{ fontSize: 13, color: '#aaa', marginTop: 2 }}>Можно загрузить до 4 файлов. Уже загружено: {files.length}</div> */}
          </div>
        )}
        {error && <div style={{ color: 'red', marginBottom: 10, textAlign: 'center' }}>{error}</div>}
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 60 }}>
            <div className="spinner" style={{ width: 32, height: 32, border: '4px solid #eee', borderTop: '4px solid #6c3be4', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
            <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}</style>
          </div>
        ) : files.length === 0 ? (
          <div style={{ color: '#888', marginBottom: 8, textAlign: 'center' }}>Нет файлов</div>
        ) : (
          <ul style={{ padding: 0, listStyle: 'none', margin: 0, marginTop: 8, maxHeight: 220, overflowY: 'auto' }}>
            {filteredFiles.map((f, i) => (
              <li key={f.fileUrl} style={{ marginBottom: 14, display: 'flex', alignItems: 'center', gap: 14, background: '#f7f7f9', borderRadius: 10, padding: 10, boxShadow: '0 1px 6px #ece9f7' }}>
                {isImage(f.fileName) ? (
                  <img src={getFileUrl(f.fileUrl)} alt={f.fileName} style={{ width: 38, height: 38, objectFit: 'cover', borderRadius: 6, boxShadow: '0 1px 4px #ddd' }} />
                ) : (
                  <span style={{ fontSize: 22, marginRight: 2 }}>📎</span>
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <a href={getFileUrl(f.fileUrl)} target="_blank" rel="noopener noreferrer" style={{ color: '#6c3be4', textDecoration: 'underline', fontSize: 16, wordBreak: 'break-all', fontWeight: 500 }}>{f.fileName}</a>
                  <div style={{ color: '#888', fontSize: 12, marginTop: 2 }}>{f.uploadedAt ? new Date(f.uploadedAt).toLocaleString() : ''}</div>
                  {f.user && <div style={{ color: '#aaa', fontSize: 12, marginTop: 2 }}>({typeof f.user === 'object' ? f.user.fullName : f.user})</div>}
                </div>
                {!readOnly && f.user && String(f.user._id) === String(currentUserId) && (
                  <button onClick={() => handleDelete(f.fileUrl)} style={{ background: 'none', border: 'none', color: '#e74c3c', fontSize: 20, cursor: uploading ? 'not-allowed' : 'pointer', borderRadius: 6, padding: 4, transition: 'background 0.2s' }} disabled={uploading} title="Удалить файл" onMouseOver={e => e.target.style.background='#fbeaea'} onMouseOut={e => e.target.style.background='none'}>🗑</button>
                )}
              </li>
            ))}
            
          </ul>
        )}
        {uploading && <div style={{ color: '#6c3be4', marginTop: 12, textAlign: 'center', fontWeight: 500 }}>Загрузка...</div>}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}

export default React.memo(FileAttachmentsModal);